import { Fragment, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "@emotion/styled";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useDispatch, useSelector } from "react-redux";
import { deleteUser, getAllUser } from "../redux/actions/AdminAction";
import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  InputAdornment,
  Paper,
  Snackbar,
  TextField,
} from "@mui/material";
import { GET_USER_RESET } from "../Constants/Constants";
import SearchIcon from "@mui/icons-material/Search";

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#282828",
    color: "#ffffff",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#e8e9eb",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function createData(
  id,
  created_at,
  first_name,
  last_name,
  email,
  role,
  contact_number
) {
  return { id, created_at, first_name, last_name, email, role, contact_number };
}

export default function ManageUsers(props) {
  const { decodedToken } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const hasAccess = (allowedRoles) => allowedRoles.includes(decodedToken?.role);

  const [row, setRow] = useState();
  const searchValue = useRef();
  const [deleteUserId, setDeleteUserId] = useState(null);
  const [snackOpen, setSnackOpen] = useState(false);
  const [dialogOpen, setdialogOpen] = useState(false);

  const GetAllUsers = useSelector((state) => state.GetAllUsers);
  const { userInfo } = GetAllUsers;

  const DeleteUser = useSelector((state) => state.DeleteUser);
  const { success, error } = DeleteUser;

  const handleDialogOpen = () => {
    setdialogOpen(true);
  };

  const handleDialogClose = () => {
    setdialogOpen(false);
  };

  const handleSnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackOpen(false);
  };

  useEffect(() => {
    dispatch(getAllUser());
  }, [dispatch]);

  useEffect(() => {
    if (userInfo) {
      const newRows = Object.values(userInfo).map((value) => {
        return createData(
          value?.user_id || "",
          value?.created_at || "",
          value?.first_name || "",
          value?.last_name || "",
          value?.email || "",
          value?.role || "",
          value?.contact_number || ""
        );
      });
      setRow(newRows);
    }
  }, [userInfo]);

  return (
    <Fragment>
      <Container>
        <Box>
          <Box sx={{ margin: 3, fontSize: 25 }}>
            Manage Users
            <Divider sx={{ marginTop: 2 }}></Divider>
          </Box>
          <Box
            sx={{
              fontSize: 25,
              margin: 3,
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            {hasAccess(["superuser"]) && (
              <Button
                type="submit"
                size="small"
                onClick={() => {
                  dispatch({ type: GET_USER_RESET });
                  navigate("/manageusers/new");
                }}
                sx={{
                  backgroundColor: "#282828",
                  color: "#ffffff",
                  width: "25vh",
                  borderRadius: 0,
                  fontSize: 16,
                  "&:hover": {
                    backgroundColor: "#282828",
                    color: "#ffffff",
                  },
                }}
              >
                Add new user
              </Button>
            )}

            <TextField
              inputRef={searchValue}
              sx={{ width: "40vh" }}
              placeholder="Search"
              onChange={(e) => {
                dispatch(getAllUser(e.target.value));
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </Box>
      </Container>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          marginBottom: "5%",
        }}
      >
        <TableContainer
          component={Paper}
          sx={{
            width: "80%",
          }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell>No.</StyledTableCell>
                <StyledTableCell>Created at</StyledTableCell>
                <StyledTableCell>First Name</StyledTableCell>
                <StyledTableCell>Last Name</StyledTableCell>
                <StyledTableCell>Email</StyledTableCell>
                <StyledTableCell>Role</StyledTableCell>
                <StyledTableCell>Contact Number</StyledTableCell>
                <StyledTableCell>Edit</StyledTableCell>
                <StyledTableCell>Delete</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {row?.length > 0 ? (
                row.map((row, index) => (
                  <StyledTableRow key={row.id}>
                    <StyledTableCell component="th" scope="row">
                      {index + 1}
                    </StyledTableCell>
                    <StyledTableCell component="th" scope="row">
                      {row.created_at}
                    </StyledTableCell>
                    <StyledTableCell
                      component="th"
                      scope="row"
                      style={{
                        wordWrap: "break-word",
                        maxWidth: "100px",
                      }}
                    >
                      {row.first_name}
                    </StyledTableCell>
                    <StyledTableCell component="th" scope="row">
                      {row.last_name}
                    </StyledTableCell>
                    <StyledTableCell
                      component="th"
                      scope="row"
                      style={{
                        wordWrap: "break-word",
                        maxWidth: "200px",
                      }}
                    >
                      {row.email.trim().split(" ").join("\n")}
                    </StyledTableCell>
                    <StyledTableCell
                      style={{
                        wordWrap: "break-word",
                        maxWidth: "180px",
                      }}
                    >
                      {row.role}
                    </StyledTableCell>
                    <StyledTableCell
                      style={{
                        wordWrap: "break-word",
                        maxWidth: "100px",
                      }}
                    >
                      {row.contact_number}
                    </StyledTableCell>
                    <StyledTableCell
                      style={{
                        wordWrap: "break-word",
                        maxWidth: "500px",
                        textAlign: "left",
                      }}
                    >
                      <Button
                        sx={{
                          backgroundColor: "#ffffff",
                          border: "1px solid black",
                          color: "black",
                          fontSize: 12,
                          height: "30px",
                        }}
                        onClick={() => navigate(`/manageusers/${row.id}`)}
                      >
                        Edit
                      </Button>
                    </StyledTableCell>
                    <StyledTableCell
                      style={{
                        wordWrap: "break-word",
                        maxWidth: "500px",
                        textAlign: "left",
                      }}
                    >
                      <Button
                        sx={{
                          backgroundColor: "#d9534f",
                          color: "white",
                          fontSize: 12,
                          height: "30px",
                          "&:hover": {
                            backgroundColor: "#d9534f",
                            color: "white",
                          },
                        }}
                        onClick={() => {
                          setdialogOpen(true);
                          setDeleteUserId(row.id);
                        }}
                      >
                        Delete
                      </Button>
                    </StyledTableCell>
                  </StyledTableRow>
                ))
              ) : (
                <StyledTableRow
                  style={{
                    wordWrap: "break-word",
                    maxWidth: "100%",
                  }}
                >
                  <StyledTableCell
                    component="th"
                    colSpan={9}
                    scope="row"
                    style={{
                      textAlign: "center",
                      wordWrap: "break-word",
                      maxWidth: "100%",
                      fontSize: 15,
                    }}
                  >
                    No data found
                  </StyledTableCell>
                </StyledTableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {success && (
          <Snackbar
            open={snackOpen}
            autoHideDuration={5000}
            onClose={handleSnackClose}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            sx={{ width: "20%" }}
          >
            <Alert
              onClose={handleSnackClose}
              severity="success"
              sx={{ width: "100%" }}
            >
              <AlertTitle>Success</AlertTitle>
              Record deleted successfully
            </Alert>
          </Snackbar>
        )}
        {error && (
          <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            open={snackOpen}
            autoHideDuration={3000}
            onClose={handleSnackClose}
            sx={{ width: "20%" }}
          >
            <Alert
              onClose={handleSnackClose}
              severity="error"
              sx={{ width: "100%" }}
            >
              <AlertTitle>Error</AlertTitle>
              {error}
            </Alert>
          </Snackbar>
        )}
        <Dialog
          open={dialogOpen}
          onClose={handleDialogOpen}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Opps!</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete this user?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDialogClose}>No</Button>
            <Button
              onClick={() => {
                dispatch(deleteUser(deleteUserId)).then(() => {
                  dispatch(getAllUser());
                  setSnackOpen(true);
                  handleDialogClose();
                });
              }}
              autoFocus
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Fragment>
  );
}
